import styled from 'styled-components';

export const TrackingDetailsHeader = styled.div`
  padding: 16px;
  font-weight: 700;
  padding: 16px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.headerAndFooter.bgColor};
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
  background-image: ${({ theme }) => {
    const {
      isGradient,
      gradientRatio,
      firstBgColor,
      firstBgColorDensity,
      secondBgColor,
      secondBgColorDensity,
    } = theme.configs.trackingDetailsBox.headerAndFooter;
    if (isGradient) {
      return `linear-gradient(${gradientRatio}deg, ${firstBgColor} ${firstBgColorDensity}%, ${secondBgColor} ${secondBgColorDensity}%)`;
    }
    return 'none';
  }};
`;
